import PropTypes from 'prop-types';
import Toggle from '../../../../juristec-ui/core/Toggle';

const ToggleInput = ({
  label, state, handle,
}) => (
  <>
    <h5 className={state.error ? 'field-error-label' : ''}>
      {label}
    </h5>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Toggle
        checked={state.value}
        handleChange={handle}
        size="small"
      />
    </div>
    {state.errorMsg.length > 0 && (
      <span className="field-error-msg">
        {state.errorMsg}
      </span>
    )}
  </>
);

ToggleInput.propTypes = {
  label: PropTypes.string.isRequired,
  state: PropTypes.shape({
    value: PropTypes.bool,
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
  }).isRequired,
  handle: PropTypes.func.isRequired,
};

export default ToggleInput;
